import { useRef } from 'react';
import SAVE_CHECK_POINT_DATA from '../queries/saveCheckPointMutation';
import useBackgroundMutation from '@apollo-internal/hooks/useBackgroundMutation';
import { useMutation } from '@apollo/client';

const useSaveCheckPoint = () => {
  const [saveBackground, saveBackgroundResult] = useBackgroundMutation(SAVE_CHECK_POINT_DATA);
  const [saveManual, saveManualResult] = useMutation(SAVE_CHECK_POINT_DATA);
  const ongoingMutation = useRef(null);

  const saveCheckPoint = async (data, isAutoSave) => {
    if (ongoingMutation.current) {
      await ongoingMutation.current;
    }

    const saveFn = isAutoSave ? saveBackground : saveManual;

    try {
      ongoingMutation.current = saveFn({
        variables: { data }
      });
      return await ongoingMutation.current;
    } finally {
      ongoingMutation.current = null;
    }
  };

  return {
    saveCheckPoint,
    saveError: saveBackgroundResult.error || saveManualResult.error,
    autoSaveInProgress: saveBackgroundResult.loading
  };
};

export default useSaveCheckPoint;
